import { Component, Inject, InjectionToken, Injector, OnInit, Optional } from '@angular/core';
import { DataFieldEditBase } from '../data-field-edit-base';
import { MatFormFieldAppearance } from '@angular/material/form-field';

export type TFiUserEditDataFieldActivation_Settings = {
    datePickerLabelStartDate: string;
    datePickerLabelEndDate: string;
    datePickerAppearance: MatFormFieldAppearance;
    isItemActivatedDisabled?: boolean;
};
export const FiUserEditDataFieldActivation_Settings = new InjectionToken<TFiUserEditDataFieldActivation_Settings>(
    'FiUserEditDataFieldActivation_Settings',
);

@Component({
    selector: 'data-field-edit-active',
    templateUrl: './active.component.html',
    standalone: false,
})
export class DataFieldEditActiveComponent extends DataFieldEditBase implements OnInit {
    constructor(
        injector: Injector,
        @Optional()
        @Inject(FiUserEditDataFieldActivation_Settings)
        private settings: TFiUserEditDataFieldActivation_Settings,
    ) {
        super(injector);
    }

    ngOnInit() {}

    getDataFieldSettings(): TFiUserEditDataFieldActivation_Settings {
        return this.settings;
    }

    isActivatedDisabled() {
        return this.settings?.isItemActivatedDisabled;
    }

    onChange() {}
}
